<template>
<div class="all-style-bgc">
    <div class="container">
        <!-- 轮播图-->
        <div class="active1 mb-20 module-bgc">
            <div class="swiper">
                <div class="block">
                    <el-carousel style="overflow:hidden !important;" trigger="click" height="321px" class="carousel-width">
                        <el-carousel-item v-for="item in imgListRotation.slice(0,5)" :key="item.id" @click.native="PicToBanner(item)">
                            <div class="lbwenzi">{{item.title}}</div>
                            <div class="background-color" :style="{backgroundImage:'url(' + item.url+ ')', 
        backgroundRepeat:'no-repeat',backgroundSize: 'cover',backgroundPosition:'center'}"></div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <FeeIn></FeeIn>
        </div>
        <!--风险防控 -->
        <div class="fxfk mb-20 mt-20">
            <div class="fxfk1 module-bgc">
                <div class="fxfk1Tit">
                    <span class="fxfktitle">公司制度</span>
                    <span class="LinkTo-qflt" @click="GoRisk">更多</span>
                </div>
                <ul class="ylkt1List ylkt1List2 pt-10 pb-10">
                    <li v-for="item in listgszd.slice(0,4)" :key="item.id">
                        <span @click="GoDetailfxfk(item)" class="float-left Link-detail" :id="item.id">{{item.title}}</span>
                        <span class="float-right list-time">{{item.publishTime}}</span>
                    </li>
                </ul>
            </div>

            <div class="fxfk1 module-bgc">
                <div class="fxfk1Tit">
                    <span class="fxfktitle">工会活动</span>
                    <span class="LinkTo-qflt" @click="GoGhhd">更多</span>
                </div>
                <ul class="ylkt1List ylkt1List2 pt-10 pb-10">
                    <li v-for="item in listghhd.slice(0,4)" :key="item.id">
                        <span @click="GoDetaildjfg(item)" class="float-left Link-detail" :id="item.id">{{item.title}}</span>
                        <span class="float-right list-time">{{item.publishTime}}</span>
                    </li>
                </ul>
            </div>
            <!-- <div class="fxfk1 module-bgc">
                <div class="fxfk1Tit">
                    <span class="fxfktitle">巡视巡察</span>
                    <span class="LinkTo-qflt" @click="GoMakeInspectionTou">更多</span>
                </div>
                <ul class="ylkt1List ylkt1List2 pt-10 pb-10">
                    <li v-for="item in listxcxs.slice(0,4)" :key="item.id">
                        <span @click="GoDetailjtdt(item)" class="float-left Link-detail" :id="item.id">{{item.title}}</span>
                        <span class="float-right list-time">{{item.publishTime}}</span>
                    </li>
                </ul>
            </div>
            <div class="fxfk1 module-bgc">
                <div class="fxfk1Tit">
                    <span class="fxfktitle">审查调查</span>
                    <span class="LinkTo-qflt" @click="GoInvestigate">更多</span>
                </div>
                <ul class="ylkt1List ylkt1List2 pt-10 pb-10">
                    <li v-for="item in listscdc.slice(0,4)" :key="item.id">
                        <span @click="GoDetailscdc(item)" class="float-left Link-detail" :id="item.id">{{item.title}}</span>
                        <span class="float-right list-time">{{item.publishTime}}</span>
                    </li>
                </ul>
            </div> -->
        </div>
        <!-- 举报电话
        <div class="banner mb-20 picFocus">
            <img :src="reportpic" alt :style="{'object-fit': 'cover'}" />
        </div> -->
        
    </div>
    <!--友情链接 -->
    <div class="yqlj-bottom">
        <div class="yqlj">
            <div class="yqlj-title">友情链接</div>
            <dl>
                <dd><a href="http://www.xajyinfo.cn" target="_blank">西安久源科技</a></dd>

            </dl>
          
            <!-- <Swiper :list="FriendPic" :width="180" :height="52" newstyle=2></Swiper> -->
        </div>
    </div>
    <!--扫码关注-->
    <!-- <scanCode></scanCode> -->
    <!--开屏动画-->
    <!-- <Open-screen v-if="showCover"></Open-screen> -->
</div>
</template>

<script>

export default {
    components: {
        'scanCode': () => import('@/views/main/Scan'),
        'openScreen': () => import('@/components/OpenScreen'),
        'Swiper': () => import('@/components/Swiper'),
        // 'Login': () => import('@/views/main/Login/Login.vue'),
        'FeeIn': () => import('@/views/main/FeeIn')
    },
    data() {
        return {
            //控制开屏动画
            showCover: false,
            imgListRotation: [],
            //举报单张图片
            reportpic: "",
            threePic: [],
            listgszd: [],
            listghhd: [],
            //友情链接
            FriendPic: []
        };
    },
    created() {
        this.reportpic = require('@/assets/image/广告1.png')
        console.log('reportpic', this.reportpic)
        
        this.listgszd.push({id:1,title:'公司福利制度',publishTime:'2021-04-30'})
        this.imgListRotation.push({url:require('@/assets/image/shoufei.png')})
        this.imgListRotation.push({url:require('@/assets/image/banner1.png')})
        //三张图轮播
        this.threePic.push({picUrl:require('@/assets/image/广告1.png')})
        this.threePic.push({picUrl:require('@/assets/image/广告2.png')})
        this.threePic.push({picUrl:require('@/assets/image/广告3.png')})
     
        this.FriendPic.push({picUrl:require('@/assets/image/链接1.png')})
        this.FriendPic.push({picUrl:require('@/assets/image/链接2.png')})
        this.FriendPic.push({picUrl:require('@/assets/image/链接3.png')})
        this.FriendPic.push({picUrl:require('@/assets/image/链接4.png')})
        this.FriendPic.push({picUrl:require('@/assets/image/链接5.png')})
        this.FriendPic.push({picUrl:require('@/assets/image/链接6.png')})
        this.FriendPic.push({picUrl:require('@/assets/image/链接6.png')})
    },

    methods: {
        //控制开屏动画次数
        showSecond() {
            if (!this.isSecond) {
                this.showCover = true;
                localStorage.setItem("isSecond", "true");
            }
        },
        GoRisk() {
            console.log('in GoRish')
        },
        GoGhhd() {
            console.log('in GoGhhd')
        }
    },
};
</script>

<style lang="less" scoped>
.container {
    width: 1200px;
    margin: 0 auto;
    background: rgba(242, 242, 242, 1);
    margin-top: 10px;
}



.big {
    background: rgba(242, 242, 242, 1);
}

.module-bgc {
    background-color: white;
}

.active1 {
    display: flex;
    padding: 20px;
}

img {
    width: 794px;
    height: 321px;
}

.banner {
    width: 1200px;
    margin: 0 auto;
}

.banner img {
    width: 100%;
    height: 120px;
}

.mb-20 {
    margin-bottom: 20px;
}

/*轮播图*/
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}

.carousel-width {
    width: 794px;
}

.carousel-width img {
    cursor: pointer;
}

/deep/.el-carousel__indicator--horizontal {
    background-color: red;
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 0);
}

/deep/.el-carousel__button {
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 1);
    border-radius: 50%;
}

/deep/.el-carousel__indicators {
    margin-left: 296px;
}

.lbwenzi {
    position: absolute;
    bottom: 0px;
    width: 782px;
    height: 48px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 48px;
    background-color: rgba(0, 0, 0, 0.7);
    padding-left: 12px;
}

/deep/.is-active {
    border-bottom: 0px;
}

/*亦廉课堂*/
.ylkt {
    /*padding: 20px 0;*/
    display: flex;
    justify-content: space-between;
    background: rgba(242, 242, 242, 1);
}

.ylkt1 {
    width: 388px;
    padding-bottom: 14px;
}

.ylkt1Tit {
    color: #dd2126;
    font-size: 18px;
    margin-bottom: 10px;
    margin-left: 20px;
    margin-right: 20px;
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 47px;
    border-bottom: 1px solid #dddddd;
}

.ylkt1Tit span {
    border-bottom: 2px solid #dd2126;
    line-height: 47px;
}

.ylkt1Tit a {
    /*float: right;*/
    color: #989898;
    text-decoration: none;
    font-size: 14px;
}

.ylkt1Img {
    width: 348px;
    height: 180px;
    margin-top: 10px;
    height: 180px;
    padding-left: 20px;
    margin-bottom: 8px;
    cursor: pointer;
}

.ylkt1List {
    margin-top: 9px;
}

.ylkt1List li .Link-detail {
    color: #333;
    font-size: 16px;
    text-decoration: none;
    line-height: 32px;
    cursor: pointer;
    display: block;
    width: 348px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.ylkt1List li {
    padding-bottom: 6px;
    padding-left: 20px;
}

.ylkt1List li span:first-child:hover {
    color: red;
}

.LinkTo-qflt {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    cursor: pointer;
}

.LinkTo-qflt:hover {
    color: red;
}

/*风险防控*/
.fxfk {
    overflow: hidden;
    margin-bottom: 20px;
}

.fxfk1 {
    width: 595px;
    margin-bottom: 10px;
    box-sizing: border-box;
    float: left;
    padding-right: 20px;
    padding-top: 17px;
}

.fxfk1:nth-child(2n + 1) {
    margin-right: 10px;
}

.fxfk1Tit {
    background: url(../../assets/image/titlebg.png) left center no-repeat;
    background-size: 130px 41px;
    background-position: 0px 0px;
    height: 41px;
    line-height: 41px;
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    border-bottom: 1px solid #dddddd;
}

.fxfk1Tit span:last-child {
    float: right;
    color: #999;
    font-size: 14px;
    line-height: 41px;
    display: block;
    text-decoration: none;
    cursor: pointer;
}

.fxfk1Tit span:last-child:hover {
    color: red;
}

.ylkt1List2 {
    height: 150px;
}

.ylkt1List2 li {
    overflow: hidden;
}

.ylkt1List2 li a {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.pl-20 {
    padding-left: 20px;
}

.pr-20 {
    padding-right: 20px;
}

.pt-10 {
    padding-top: 10px;
}

.pb-10 {
    padding-bottom: 10px;
}

.mt-20 {
    margin-top: 20px;
}

.float-left {
    float: left;
}

.float-right {
    float: right;
}

.float-right.list-time {
    font-size: 16px;
    line-height: 22px;
    color: rgba(153, 153, 153, 1);
}

.fxfktitle {
    padding-left: 20px;
}

/*三张图片、广告*/
.three-pic {
    display: flex;
    justify-content: center;
    background-color: white;
    padding: 20px;
}

.three-pic a {
    display: block;
}

.three-pic>a>img {
    width: 372px;
    height: 90px;
    margin-right: 22px !important;
}

.three-pic .Last-pic {
    margin-right: 0px !important;
}

/*友情链接*/
.yqlj-bottom {
    width: 100%;
    background-color: white;
    height: 100px;
}


.yqlj {
    width: 1200px;
    margin: 0 auto;
}
.yqlj dd {
  margin-top: -20px;
  float:left;
  padding-left: 20px; 
  text-decoration:underline; /* 下划线 */
}
.yqlj dd a {
 font-size: 14px;
}
.yqlj-title {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 90px;
    font-weight: 600;
}
.yqlj ul {
    display: flex;
    justify-content: space-between;
}
.yqlj ul li {
    float:left; /* 往左浮动 */
    list-style:none; /* 将默认的列表符号去掉 */
    padding:0; /* 将默认的内边距去掉 */
    margin:0; /* 将默认的外边距去掉 */
}

.yqlj ul li a {
    // display:block; /* 将链接设为块级元素 */
    padding:8px 50px; /* 设置内边距 */
    // background:#3A4953; /* 设置背景色 */
    // color:#fff; /* 设置文字颜色 */
    text-decoration:underline; /* 下划线 */
    // border-right:1px solid #000; /* 在左侧加上分隔线 */
}

//情分论坛图片的大小
.picFocus {
    width: 1200px;
    height: 120px;
}

.ylkt1Img-pic-box {
    width: 348px;
    height: 180px;
    overflow: hidden;
}

.background-color {
    width: 795px;
    height: 320px;
    cursor: pointer;
}
</style>
